import ConsoleSetting from './TimeZone/ConsoleSetting';
import EmailAndCollaboration from '../../pages/Welcome/EmailAndCollaboration';

const headerRouter = [
  {
    path: '/console-setting',
    element: ConsoleSetting,
    name: 'header.consoleSetting.router.title',
  },
  {
    path: '/welcome',
    element: EmailAndCollaboration,
    name: 'common.nativeApp.productName',
  },
];

export default headerRouter;
